export default __webpack_public_path__ + "static/media/Oxford.74b7256c.webp";